module.exports = __webpack_public_path__ + "static/media/salak_ra_balak_music_video_compilation_v2.adb00598.mp4";